import cx from 'classnames';

// Design System
import { TertiaryButton } from 'jl-design-system/elements/button/Button';

// Types
import { PaymentDeductionsItemActionButtonProps } from './PaymentDeductionsItemActionButton.types';

// Styles
import styles from './payment-deductions-item-action-button.scss';

const PaymentDeductionsItemActionButton = ({
  children,
  className = '',
  dataTest = '',
  isLoading = false,
  onClick = () => {},
}: PaymentDeductionsItemActionButtonProps) => (
  <TertiaryButton
    className={cx({
      [className]: !!className,
      [styles.buttonLoading]: isLoading,
      [styles.button]: !isLoading,
    })}
    data-testid={dataTest}
    onClick={onClick}
    small
    submitting={isLoading}
  >
    {children}
  </TertiaryButton>
);

export default PaymentDeductionsItemActionButton;
